var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSootheSensitive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-soothe"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-463.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Soothe-Sensetive",
    transform: "translate(465.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-soothe"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-soothe"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9482,11 C26.9482,11 25.2202,11.59 23.3422,12.838 C24.0842,16.518 22.7752,20.263 20.0002,24 C21.6002,23.191 23.8382,21.772 25.2062,19.65 C26.5622,17.547 26.9632,14.86 26.9862,13.041 C27.0002,12 26.9482,11 26.9482,11 Z M18.0002,5 C18.0002,5 14.0002,9.929 14.0002,15 C14.0002,17.426 15.1732,21.594 18.0002,25 C18.0002,25 22.0002,20.071 22.0002,15 C22.0002,9.823 18.0002,5 18.0002,5 Z M12.6782,12.844 C10.7902,11.592 9.0002,11 9.0002,11 L9.0002,12 C9.0002,14 9.1392,17.09 10.8012,19.659 C12.1672,21.771 14.3942,23.188 16.0002,24 C13.2442,20.332 11.9152,16.53 12.6782,12.844 Z M28.0002,17 C27.4612,19.05 26.0262,22.264 21.0002,25 C22.5322,24.914 24.5282,24.591 26.2602,23.623 C29.5522,21.78 31.0002,17 31.0002,17 L28.0002,17 Z M8.0002,17 L5.0002,17 C5.0002,17 6.4482,21.751 9.7412,23.61 C11.4712,24.588 13.4682,24.913 15.0002,25 C10.0112,22.284 8.5352,19.057 8.0002,17 Z M18.0002,30 C15.2592,30 10.5302,29.252 9.3002,26.465 C9.1572,26.142 9.1872,25.77 9.3802,25.474 C9.5722,25.179 9.9012,25 10.2542,25 L10.2582,25 C10.6452,25 11.0012,25.215 11.1812,25.558 C11.9232,26.966 14.6992,28 18.0002,28 C21.3012,28 24.0772,26.966 24.8182,25.558 C24.9992,25.215 25.3552,25 25.7422,25 L25.7462,25 C26.0992,25 26.4272,25.178 26.6212,25.474 C26.8132,25.77 26.8432,26.142 26.7002,26.465 C25.4692,29.252 20.7412,30 18.0002,30 Z",
    id: "Fill-1",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSootheSensitive);
export default __webpack_public_path__ + "static/media/SootheSensitive.0b645ddef9c3ba49ebda0778ad73492a.svg";
export { ForwardRef as ReactComponent };